import React from 'react';
import styled from 'styled-components';
import { Colors } from '@inplayer-org/inplayer-ui';

// components
import ClipBoardButton from 'components/ClipBoardButton';
import BaseModal from 'components/Modals/BaseModal';

// types
import { ModalNames } from 'ducks/merchantDucks/modal/types';

interface Props {
  secret: string;
}

const SecretKeyParagraph = styled.p`
  font-size: ${({ theme }) => theme.font.sizes.small};
  margin: 18px 0;
  color: ${({ theme }) => theme.palette.text.light};
`;

const KeySection = styled.div`
  border: 1px solid ${Colors.gray};
  border-radius: 3px;
  padding: 20px;
  font-size: 14px;
  background: ${Colors.lightGray};
  line-height: 1.4em;
  white-space: -moz-pre-wrap;
  white-space: -o-pre-wrap;
  margin: 1em 0px 1em;
  height: 120px;
`;

const KeyWrapper = styled.span`
  display: block;
  margin-bottom: 17px;
  font-family: monospace;
  min-height: 1.2rem;
`;

const SecretKeyModal = ({ secret }: Props) => {
  return (
    <BaseModal
      modalName={ModalNames.SecretKey}
      title="OAuth App Secret Key"
      render={() => (
        <>
          <SecretKeyParagraph>
            Using your OAUTH key and app secret key you can get an access token and establish a machine-to-machine
            integration for retrieving your merchant information.
            <br />
            Your OAUTH app secret key is provided below. Please copy and save it as it will be shown only once. You can
            always generate a new one at later times.
          </SecretKeyParagraph>
          <KeySection>
            <KeyWrapper>{secret}</KeyWrapper>
            <ClipBoardButton disabled={!secret} clipboardText={secret} tooltipText="Copied!">
              {secret ? 'Copy app secret key' : 'Fetching app secret...'}
            </ClipBoardButton>
          </KeySection>
        </>
      )}
    />
  );
};

export default SecretKeyModal;
